import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { Location } from '@angular/common';

import * as _ from 'lodash';

import { ModalComponent } from '../../modal/modal.component';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import { AssociateEquipmentService } from './associateequipment-plugin.service';
import { InspectionService } from '../../shared/services';
import { Inspection } from '../../shared/models';

@Component({
    selector: 'associateequipment-edit',
    templateUrl: './associateequipment-edit.component.html',
    standalone: false
})
export class AssociateEquipmentEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pluginId: string;
  inspection: Inspection;
  public plugin: any;
  public childrenInspections: Inspection[];
  public processing = false;
  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true }) deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private service: AssociateEquipmentService,
    private router: Router,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private inspectionService: InspectionService
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) {
        this.router.navigate([this.inspectionsRoute]);
      }

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) {
        this.goToBack();
      }

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service.updateAssociates(this.inspectionId, this.pluginId).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.service.cancel();
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    if (this.service.associateInspections) {
      this.childrenInspections = [...this.service.associateInspections];
    } else {
      this.inspectionService.getInspection(this.inspectionId).subscribe((el) => {
        this.inspection = el;
        this.childrenInspections = [...el.children];
        this.service.setInspections(this.childrenInspections);
        this.cdRef.detectChanges();
      });
    }
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  add() {
    this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'plugins',
      this.pluginId,
      'associateequipment',
      'select'
    ]);
  }

  remove(item: any) {
    this.childrenInspections = this.childrenInspections.filter((c) => c.id !== item.id);
    this.service.deleteInspection(item);
  }
}
